/* eslint-disable */
import _ from "lodash";

// Null判定
export function isNull(obj: any) {
    return _.isNull(obj);
}

// Undefined判定
export function isUndefined(obj: any) {
    return _.isUndefined(obj);
}

// Null/Undefined判定
export function isNullorUndefined(obj: any) {
    return _.isNil(obj);
}

// 空オブジェクト判定
export function isEmpty(obj: any) {
    return _.isEmpty(obj) && obj !== 0 && typeof obj !== "boolean";
}

// String判定
export function isString(obj: any) {
    return _.isString(obj);
}

// Number判定
export function isNumber(obj: any) {
    return _.isNumber(obj);
}

// ObjectをArrayに変換する
export function toArray(obj: any) {
    return _.toArray(obj);
}

// オブジェクトをクローンする
export function clone(obj: any, customizer?: any){
    return _.cloneDeepWith(obj, customizer);
}

// 文字列前後の空白と指定内容を削除する
export function trim(str: string | undefined, chars?: string) {
    return _.trim(str, chars);
}

// 配列の重複を除外する
export function uniq(arr: Array<any> | null | undefined) {
    return _.uniq(arr);
}

// オブジェクトから対象項目を抽出する
export function pick(obj: Object | null | undefined, targets: string | string[]) {
    return _.pick(obj, targets);
}

// オブジェクトからValueを抽出する
export function values(obj: any) {
    return _.values(obj);
}

// 配列の比較
export function isArrayEuqual(arr1: Array<any> | null | undefined, arr2: Array<any> | null | undefined) {
    return _.isEqual(_.uniq(_.sortBy(arr1)), _.uniq(_.sortBy(arr2)));
}

// ファイルの拡張子からファイルタイプを判断する
export function CheckFileType(fileType: string, fileName: string) {
    if (fileType.includes("csv") || (fileType.includes("excel") && fileName.split(".")[fileName.split(".").length - 1] === "csv")) {
        return "csv";
   } else if (fileType.includes("msword") || fileType.includes("wordprocessingml")) {
        return "word";
   } else if (fileType.includes("pdf")) {
        return "pdf";
   } else if(fileType.includes("powerpoint") || fileType.includes("presentationml")) {
        return "powerPoint";
   } else if(fileType.includes("plain")) {
        return "text";
   } else if(fileType.includes("excel") || fileType.includes("spreadsheetml")) {
        return "excel";
   } else if (fileType.includes("zip")) {
        return "zip";
   } else {
        return "other";
   }
}

// ファイル名の拡張子を抜いたファイル名を返す
export function ExtractFileName(fileName: string){
    const index = fileName.lastIndexOf(".");
    if(index > 0){
        return fileName.substring(0, fileName.lastIndexOf("."));
   }
    else{
        return fileName;
   }
}

// 文字数カウント
export function CountWord(word: string): number{
    let count = 0;
    for (let i = 0; i < word.length; i++) {
        if(word[i].match(/[ -~]/) ) {
            count += 0.5;
       }
        else {
            count += 1;
       }
   }
    return count;
}
